import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { ThemeResponseDto } from '../../../store/landscapeAPI/theme/dto/response/theme-response.dto';
import { Button, Label } from '../../atoms';
import {
  ReportingDetailsThemesForm,
  TranslationOrganism,
} from '../../organisms';
import BaseTemplate from '../BaseTemplate';
import cn from 'classnames';
import styles from './ReportingDetailsThemesAddTemplate.module.css';
import { ImageMeta } from '../../../store/mediaAPI/media/dto/request/media-save-request';
import { LocalesLanguagesConstants } from '../../../locales/locales';
import { PromiseSettledResult } from '../../../utils/types/types';

interface ReportingDetailsThemesAddTemplateProps {
  data: ThemeResponseDto;
  handleAddTheme: (theme: ThemeResponseDto) => void;
  handleOnChange: (theme: ThemeResponseDto) => void;
  handleImageOnChange: (imageMeta: ImageMeta) => void;
  setLanguage: React.Dispatch<React.SetStateAction<LocalesLanguagesConstants>>;
  selectedLanguage: LocalesLanguagesConstants;
  fromLanguage: LocalesLanguagesConstants;
  setFromLanguage: React.Dispatch<
    React.SetStateAction<LocalesLanguagesConstants>
  >;
  toLanguage: LocalesLanguagesConstants;
  setToLanguage: React.Dispatch<
    React.SetStateAction<LocalesLanguagesConstants>
  >;
  generateTranslation: () => Promise<void>;
  generateAllTranslations: () => Promise<PromiseSettledResult<void>[]>;
}

const ReportingDetailsThemesAddTemplate: FC<
  ReportingDetailsThemesAddTemplateProps
> = ({
  data,
  handleAddTheme,
  handleOnChange,
  handleImageOnChange,
  setLanguage,
  selectedLanguage,
  fromLanguage,
  setFromLanguage,
  toLanguage,
  setToLanguage,
  generateTranslation,
  generateAllTranslations,
}) => {
  const navigate = useNavigate();
  return (
    <BaseTemplate>
      <div className={styles.heading}>
        <Label content="Create Theme" size="lg" />
        <Button
          variant="link"
          onClick={() => navigate('/reporting-details/themes')}
          className={cn(styles.buttonLink)}
        >
          Go back to theme overview
        </Button>
      </div>
      <TranslationOrganism
        setLanguage={setLanguage}
        selectedLanguage={selectedLanguage}
        fromLanguage={fromLanguage}
        setFromLanguage={setFromLanguage}
        toLanguage={toLanguage}
        setToLanguage={setToLanguage}
        generateTranslation={generateTranslation}
        generateAllTranslations={generateAllTranslations}
      />
      <ReportingDetailsThemesForm
        data={data}
        callbackFn={handleAddTheme}
        handleOnChange={handleOnChange}
        handleImageOnChange={handleImageOnChange}
      />
    </BaseTemplate>
  );
};

export default ReportingDetailsThemesAddTemplate;
